import * as React from 'react';
import * as ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import { RootApp } from 'HelperFunctions/root';

// export const history = createHistory();

ReactDOM.render(<RootApp />, document.getElementById('root'));
registerServiceWorker();
if (navigator.serviceWorker) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
}



// WEBPACK FOOTER //
// ./src/index.tsx